import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    customRadioButton: {
        '& .MuiSvgIcon-root ': {
            borderRadius: '100%',
            background: '#26314e',
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.MuiRadio-colorSecondary.Mui-checked:hover': {
            backgroundColor: 'transparent',
        },
        '&:not(.Mui-checked) + span': {
            color: '#6F7FA4',
        }
    }
}));

export default useStyles;
